"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const browser_plugin_button_click_tracking_1 = require("@snowplow/browser-plugin-button-click-tracking");
const utils_1 = require("../../utils");
const constants_1 = require("../constants");
const buttonClickTrackingWithDynamicContexts = (enabled, dynamicEntities = [], additionalEntities = []) => {
    return {
        enabled,
        plugin: browser_plugin_button_click_tracking_1.ButtonClickTrackingPlugin,
        enablePlugin: () => {
            // This config replaces the default rather than merging with it, so the
            // label fallback has to be repeated here or icon-only buttons lose it.
            (0, browser_plugin_button_click_tracking_1.enableButtonClickTracking)({
                defaultLabel: constants_1.buttonLabelFallback,
                context: [
                    ...(0, utils_1.generateDynamicButtonClickContextFunctions)(dynamicEntities),
                    ...additionalEntities,
                ],
            });
        },
    };
};
exports.default = buttonClickTrackingWithDynamicContexts;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYnV0dG9uQ2xpY2tUcmFja2luZ1dpdGhEeW5hbWljQ29udGV4dHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvcGx1Z2lucy9vdmVycmlkZXMvYnV0dG9uQ2xpY2tUcmFja2luZ1dpdGhEeW5hbWljQ29udGV4dHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSx5R0FHd0Q7QUFHeEQsdUNBQXlFO0FBRXpFLDRDQUFtRDtBQUVuRCxNQUFNLHNDQUFzQyxHQUFHLENBQzNDLE9BQWdCLEVBQ2hCLGtCQUFrQyxFQUFFLEVBQ3BDLHFCQUE2RSxFQUFFLEVBQ25FLEVBQUU7SUFDZCxPQUFPO1FBQ0gsT0FBTztRQUNQLE1BQU0sRUFBRSxnRUFBeUI7UUFDakMsWUFBWSxFQUFFLEdBQUcsRUFBRTtZQUNmLHVFQUF1RTtZQUN2RSx1RUFBdUU7WUFDdkUsSUFBQSxnRUFBeUIsRUFBQztnQkFDdEIsWUFBWSxFQUFFLCtCQUFtQjtnQkFDakMsT0FBTyxFQUFFO29CQUNMLEdBQUcsSUFBQSxrREFBMEMsRUFBQyxlQUFlLENBQUM7b0JBQzlELEdBQUcsa0JBQWtCO2lCQUN4QjthQUNKLENBQUMsQ0FBQztRQUNQLENBQUM7S0FDSixDQUFDO0FBQ04sQ0FBQyxDQUFDO0FBRUYsa0JBQWUsc0NBQXNDLENBQUMifQ==


// WEBPACK FOOTER //
// ../../../../src/plugins/overrides/buttonClickTrackingWithDynamicContexts.ts